import React, { useState } from "react";
import { NivoTimeSeriesLine } from "./visualizations/nivo-line";
import "styled-components/macro";
import { css } from "styled-components";
import { Card, Elevation, Tab, Tabs } from "@blueprintjs/core";
import { PlannerStats } from "./components/planner-stats";
import { useFullScreenModeEnabled } from "./store/model-misc";

const DEFAULT_TAB_ID =
  window.localStorage.getItem("platform-stats:selected-tab-id") ?? "detail";

export function PlatformStats() {
  const [selectedTabId, setSelectedTabId] = useState(DEFAULT_TAB_ID);
  const handleTabChange = (newTabId, prevTabId, event) => {
    window.localStorage.setItem("platform-stats:selected-tab-id", newTabId);
    setSelectedTabId(newTabId);
  };
  const fullScreen = useFullScreenModeEnabled();
  const extraCss = fullScreen
    ? css`
        & .bp3-tab-list {
          display: none !important;
        }
        & .bp3-tab-panel {
          margin-top: 0 !important;
        }
      `
    : css`
        margin-top: -15px;
      `;
  return (
    <div
      css={`
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
      `}
    >
      <Tabs
        onChange={handleTabChange}
        selectedTabId={selectedTabId}
        large
        renderActiveTabPanelOnly={true}
        css={`
          width: 100%;
          height: 100%;
          ${extraCss}
        `}
      >
        <Tab
          id="detail"
          title="Detail"
          panel={<DetailView />}
          // css={`
          //   width: 100%;
          //   height: 100%;
          // `}
        />
        <Tab
          id="visualizations"
          title="Visualizations"
          panel={<Visualizations />}
          // css={`
          //   width: 100%;
          //   height: 100%;
          // `}
        />
      </Tabs>
    </div>
  );
}

function DetailView() {
  return (
    <PlannerStats
      initialData={{ start_timestamp: "", end_timestamp: "", succinct: true }}
      showControlPanel={false}
    />
  );
  // const { data, loading } = useAppModeEndpoint("succinct_planner_stats");
  // return loading ? <Spinner /> : <RawDataInner data={data} />;
}

function Visualizations() {
  const height = 325;
  const width = 650;
  return (
    <div
      css={`
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 40px;
      `}
    >
      <div
        css={`
          display: flex;
          flex-wrap: wrap;

          margin: -10px -20px -20px;
          & > * {
            margin: 20px;
          }

          & .bp3-card.bp3-card {
            padding-top: 10px;
          }
        `}
      >
        <Card elevation={Elevation.TWO}>
          <NivoTimeSeriesLine
            endpoint={"daily_cumsum_total_target_savings"}
            height={height}
            width={width}
          />
        </Card>
        <Card elevation={Elevation.TWO}>
          <NivoTimeSeriesLine
            endpoint={"daily_cumsum_total_baseline_savings"}
            height={height}
            width={width}
            yTicks={[0.5e6, 1.0e6, 1.5e6, 2.0e6]}
          />
        </Card>
        <Card elevation={Elevation.TWO}>
          <NivoTimeSeriesLine
            endpoint={"daily_cumsum_num_bookings"}
            height={height}
            width={width}
          />
        </Card>
        <Card elevation={Elevation.TWO}>
          <NivoTimeSeriesLine
            endpoint={"daily_cumsum_num_tickets_booked"}
            height={height}
            width={width}
          />
        </Card>
      </div>
    </div>
  );
}
